import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { LOCAL_NAVBAR_STATUS_KEY } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { OrderDetailsGeneralComponent } from '../order-details-general/order-details-general.component';
import { OrderDetailsInstallmentsComponent } from '../order-details-installments/order-details-installments.component';
import { OrderDetailsDecidoComponent } from '../order-details-decido/order-details-decido.component';
import { OrderDetailsQineticComponent } from '../order-details-qinetic/order-details-qinetic.component';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent {
  @ViewChild(OrderDetailsGeneralComponent) general_component?: OrderDetailsGeneralComponent;
  @ViewChild(OrderDetailsInstallmentsComponent) installments_component?: OrderDetailsInstallmentsComponent;
  @ViewChild(OrderDetailsDecidoComponent) decido_component?: OrderDetailsDecidoComponent;
  @ViewChild(OrderDetailsQineticComponent) qinetic_component?: OrderDetailsQineticComponent;

  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(NavigationItemLabel.orders);

  store_id: string | null;
  order_id: string | null;

  tabs = this.navigation_service.navigation_set.order_details_tabs;
  current_tab = this.tabs.get('article');

  constructor(
    private navigation_service: NavigationService,
    private utils_service: UtilsService,
    private route: ActivatedRoute,
  ) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
    this.store_id = this.route.snapshot.paramMap.get('store_id');
    this.order_id = this.route.snapshot.paramMap.get('order_id');
  }

  ngOnInit(): void {
    this.current_tab = this.tabs.get('article');
  }

  onRefresh(): void {
    if (this.current_tab === this.tabs.get('article')) {
      this.general_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('list')) {
      this.installments_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('arrow_split')) {
      this.decido_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('computer')) {
      this.qinetic_component?.onRefresh();
    }
  }

  onTabChange(current_tab: string): void {
    this.current_tab = current_tab;
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }
}
